const mutations = {
  _SAVE_TEXTS: 'SAVE_TEXTS',
  _SAVE_TEXT: 'SAVE_TEXT',
  _SAVE_PARAGRAPH: 'SAVE_PARAGRAPH',
  _SAVE_TEXT_READABILITY: 'SAVE_TEXT_READABILITY',
};

export default {
  mutations,
};
